import React from 'react'
import Navbar from '../components/Navbar'
import ReadAndSelectComp from '../components/ReadAndSelectComp'
import Footer from '../components/Footer'

function ReadAndSelect() {
  return (
    <>
    <Navbar />
    <ReadAndSelectComp />
    <Footer />
    </>
  )
}

export default ReadAndSelect


